// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ETsB1","content":"styles_content__n9I_J","checkbox":"styles_checkbox__3ZiaY","checkboxLabel":"styles_checkboxLabel__1p1MY"};